import "./styles.scss";

import { Link, useLocation } from "react-router-dom";
import { AnimatePresence, motion } from "framer-motion";

import { useTimeTracking } from "context/time-tracking";

import TrackerButton from "components/TrackerButton";

const mainClass = "time-tracker";

const TimeTracker = () => {
  const { pathname } = useLocation();
  const { current, timeTracking } = useTimeTracking();

  const task = current?.tasks?.[0];
  const Tag = pathname.includes(task?._id) ? "span" : Link;

  return (
    <AnimatePresence>
      {task && (
        <motion.div
          className={mainClass}
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ type: "tween", duration: 0.2 }}
        >
          <div className={`${mainClass}__title`}>
            <p>
              <Tag {...(Tag === Link && { to: `/tasks/${task._id}` })}>
                {task.title}
              </Tag>
            </p>
          </div>
          <div className={`${mainClass}__spacer`} />
          <div className={`${mainClass}__timer`}>
            <TrackerButton
              start_time_tracked={current?.start}
              onClick={() => timeTracking(current?.tasks?.[0]?._id)}
            />
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default TimeTracker;
